<template lang="pug">
  .post-image(v-if="image" ref="container" :style="{ width: `${width}px` }")
    figure(:style="{ height: `${height}px` }")
      img(
        v-lazy="image"
        v-if="maxWidth"
        :title="title"
        :style="{ width: `${width}px`, height: `${height}px` }"
        rel="noopener"
      )
    p(v-if="title") {{ title }}
    small(v-if="text" v-html="text")

</template>

<script>
import { get, trim } from '@/helpers';

export default {
    name: 'PostImage',
    data() {
        return {
            // maxW: undefined,
            // aspectRatio: undefined,
            // w: undefined,
            // h: undefined,
        };
    },
    props: {
        content: {
            type: Object,
            required: true
        },
        count: {
            type: Number,
            required: true
        },
        maxWidth: {
            type: Number
        },
        shadow: {
            type: String,
            default: 'box-shadow-2'
        }
    },
    computed: {
        title() {
            return get(this.content, 'title');
        },
        text() {
            return get(this.content, 'text');
        },
        image() {
            const image = get(this.content, 'images.0');
            if (!image || !this.maxWidth) return false;

            let fit = get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1';
            const parameters = {
                // ...get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                // ...get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups')
            };
            // let { w, h, fx, fy, fz } = parameters;
            let { w, h, fz } = parameters;
            if (!fz) fz = 1;

            // if (w && h) {
            //   fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${this.w}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${this.h}`)
            // } else if (! w && ! h) {
            //   fit += `&h=${this.h}`
            // }

            let width, height, aspectRatio;

            width = image.width / fz;
            height = image.height / fz;
            aspectRatio = width / height;

            if (w && h) {
                aspectRatio = w / h;
                height = Math.min(this.maxWidth, width) / aspectRatio;

                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`);
            } else if (!w && !h) {
                fit += `&w=${Math.min(this.maxWidth, width)}`;
            }

            // if (height > 500) {
            //   height = 500
            //   width = height * aspectRatio
            // }

            const storageRoute = trim(
                `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                '/'
            );

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
                width,
                height,
                aspectRatio
            };
        },
        width() {
            if (this.image.width) return Math.min(this.maxWidth, this.image.width);
            else return this.maxWidth;
        },
        height() {
            if (this.width && this.image.aspectRatio) return this.width / this.image.aspectRatio;
            else return undefined;
        }
    }
    // mounted() {
    //   const calculateMaxWidth = () => {
    //     if (this.$refs.container) {
    //       const style = getComputedStyle(this.$refs.container)
    //       this.maxW = this.$refs.container.clientWidth
    //       this.maxW -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
    //     }
    //   }

    //   window.addEventListener('resize', debounce(calculateMaxWidth, 100))
    //   calculateMaxWidth()
    // }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

.content .post-image
  // width: 100%
  margin-bottom: 10px
  img
    // width: auto
    // height: initial
    width: 100%
    height: auto
    display: inline-block
    &[lazy=loading]
      box-shadow: none
  p
    margin-bottom: 0
    font-size: .8rem
  small
    font-size: .65rem
  figure
    display: block
    background: $skeletonColor
    margin-bottom: 2px
</style>
